import {GlobalEventsMap, INSUFFICIENT_FUNDS, INTERNAL_ERROR} from '@gongxigames/framework/slot';
import {GameServerError, RubyPlayErrorsHandler} from '@gongxigames/framework/integrations/rubyplay/RubyPlayErrorsHandler';
import {consoleLogger} from '@gongxigames/framework/core';
import {PSGameClientWrapperEvents} from '@gongxigames/framework/integrations/pokerstars/PSGameClientWrapperEvents';
import {RG2XCError} from '@gongxigames/framework/integrations/pokerstars/PSTypes';

const RECOVERED_ERRORS_IN_GAME: string[] = [
    'GS-98'
];

const MESSAGE_VALIDATION_ERROR = 'GS-21';
const ILLEGAL_STATE_ERROR = 'GS-22';
const INVALID_USER_ERROR = 'GS-23';
const SYSTEM_ERROR = 'GS-24';
const TEMPORARY_UNAVAILABLE_ERROR = 'GS-25';
const INSUFFICIENT_FUNDS_ERROR = 'GS-5';

const XC_LAUNCH_ERRORS = {
    SystemError: '524',
    TemporaryUnavailableError: '525',
    MessageValidationError: '521',
    IllegalStateError: '522',
    SessionTerminatedError: '108',
    InvalidUserError: '523'
};

const XC_BY_GS_ERRORS_MAP: Record<string, string> = {
    'GS-0': 'genericError',
    'GS-7': 'sessionExpiredError',
    [INSUFFICIENT_FUNDS_ERROR]: 'insufficientFundsError',
    [TEMPORARY_UNAVAILABLE_ERROR]: 'genericXCError',
    [MESSAGE_VALIDATION_ERROR]: 'genericError',
    [SYSTEM_ERROR]: 'systemError',
    [INVALID_USER_ERROR]: 'genericError',
    [ILLEGAL_STATE_ERROR]: 'genericError',
    [XC_LAUNCH_ERRORS.SystemError]: 'systemError',
    [XC_LAUNCH_ERRORS.IllegalStateError]: 'genericError',
    [XC_LAUNCH_ERRORS.MessageValidationError]: 'genericError',
    [XC_LAUNCH_ERRORS.InvalidUserError]: 'genericError',
    [XC_LAUNCH_ERRORS.SessionTerminatedError]: 'genericError',
    [XC_LAUNCH_ERRORS.TemporaryUnavailableError]: 'genericXCError'
} as const;

export class PSErrorsHandler extends RubyPlayErrorsHandler {
    private static isErrorRecoveredInGame(code: string): boolean {
        return RECOVERED_ERRORS_IN_GAME.includes(code);
    }

    public handleGameClientInsufficientFundsError(): void {
        this.handleUnrecoverableErrors(INSUFFICIENT_FUNDS_ERROR);
    }

    public handleGameServerError(error: GameServerError): void {
        this._gameServerError = error;

        const {code} = error.data;

        if (PSErrorsHandler.isErrorRecoveredInGame(code)) {
            this.sendMessageError(this.getMessageError());
        } else {
            this.handleUnrecoverableErrors(code);
        }

        if (code === INSUFFICIENT_FUNDS_ERROR) {
            this.getEventManager<GlobalEventsMap>().emit('General.Message.SHOW', INSUFFICIENT_FUNDS);
        } else if (!PSErrorsHandler.isErrorRecoveredInGame(code)) {
            INTERNAL_ERROR.buttons = [{action: 'reload', title: {id: 'reload'}}];

            this.getEventManager<GlobalEventsMap>().emit('General.Message.SHOW', INTERNAL_ERROR);
        }

        consoleLogger.error(error);
    }

    public handleRequestError(xhr: XMLHttpRequest, isTimeout: boolean): void {
        this.getEventManager<PSGameClientWrapperEvents>().emit('PokerStartsErrorHandler.gameError', {error: 'communicationError'});

        consoleLogger.error(xhr);
    }

    public handleLaunchError(error: {code: string; description: string; errorDisplayOptions: any;}): void {
        this.handleUnrecoverableErrors(error.code);

        consoleLogger.error(error);
    }

    public handleInitSessionError(error: any): void {
        this.handleUnrecoverableErrors(error.code);

        consoleLogger.error(error);
    }

    private handleUnrecoverableErrors(errorCode: string): void {
        const xcClientError: RG2XCError = {
            error: ''
        };

        if (XC_BY_GS_ERRORS_MAP[errorCode]) {
            xcClientError.error = XC_BY_GS_ERRORS_MAP[errorCode];
        } else {
            xcClientError.error = 'genericError';
        }

        if (xcClientError.error === 'genericXCError') {
            xcClientError.details = 'TemporaryUnavailableError';
        }

        this.getEventManager<PSGameClientWrapperEvents>().emit('PokerStartsErrorHandler.gameError', xcClientError);
    }
}
